import React, {useEffect} from 'react';
import * as S from '../AmenitiesPhotosTabContent/AmenitiesPhotos.styles';
import Icon from '../../../../../../stories/core-components/IconsSelector';
import Loader from './../../SrpLoader/Loader/Loader';
import ContentUnavailable from './../../SrpErrorStates/ContentUnavailable';
import {SEAT_LAYOUT} from './../../../../../config/messages';
import {getIconName} from './../../../../../containers/Common/config';
import {scrollEletoView} from './../../../../../containers/Common/Utils';

const AmenitiesPhotos = props => {
  const {data, isLoading, error, routeId} = props;
  useEffect(() => {
    const idOfElToScrollTo = `#amenitiesPhotos${routeId.replace('@', '')}`;
    scrollEletoView(idOfElToScrollTo, {
      behavior: 'smooth',
    });
  }, []);

  if (error) {
    return (
      <S.AmenitiesPhotosWrap id={`amenitiesPhotos${routeId.replace('@', '')}`}>
        <ContentUnavailable text={SEAT_LAYOUT.AMENITIES_PHOTOS_NOTFOUND} />
      </S.AmenitiesPhotosWrap>
    );
  }
  if (isLoading) {
    return (
      <S.AmenitiesPhotosWrap id={`amenitiesPhotos${routeId.replace('@', '')}`}>
        <Loader></Loader>
      </S.AmenitiesPhotosWrap>
    );
  }
  const {photos, amenities} = data;

  return (
    <S.AmenitiesPhotosWrap id={`amenitiesPhotos${routeId.replace('@', '')}`}>
      <S.Header>Amenities</S.Header>
      <S.AmenitiesWrap>{getAmenitiesView(amenities)}</S.AmenitiesWrap>
      {photos && photos.length ? (
        <S.PhotosWrap>
          <S.Header>Photos</S.Header>
          <S.ScrollerWrap>
            <S.Scroller>{getPhotosView(photos)}</S.Scroller>
            {false ? (
              <>
                <S.Arrows className="left">
                  <Icon
                    name="ArrowRight"
                    styleProps={{
                      fill: 'white',
                      width: '1rem',
                      height: '1rem',
                      transform: 'rotate(-180deg)',
                    }}
                  />
                </S.Arrows>
                <S.Scroller>{getPhotosView(photos)}</S.Scroller>
                <S.Arrows className="right">
                  <Icon
                    name="ArrowRight"
                    styleProps={{fill: 'white', width: '1rem', height: '1rem'}}
                  />
                </S.Arrows>
              </>
            ) : null}
          </S.ScrollerWrap>
        </S.PhotosWrap>
      ) : null}
    </S.AmenitiesPhotosWrap>
  );
};

export default AmenitiesPhotos;
function getAmenitiesView(amenities) {
  const view = [];
  if (amenities && amenities.length) {
    amenities.map((item, index) => {
      const iconName = getIconName(item) || '';

      view.push(
        <S.Amenities key={item + index}>
          <Icon name={iconName} />
          <S.AmenitiesTxt>{item}</S.AmenitiesTxt>
        </S.Amenities>,
      );
    });
  }
  return view;
}

function getPhotosView(photos) {
  let view = [];
  for (let i in photos) {
    view.push(
      <S.ImgBox key={photos[i].u}>
        <img src={photos[i].u} alt="" style={{height: '100%', width: '100%'}}></img>
      </S.ImgBox>,
    );
  }
  return view;
}
